import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicFlynnsTaxonomy = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Classification of Models - Flynn’s Taxonomy (SISD, SIMD, MISD, MIMD)"
      videos={[
        "https://www.youtube.com/embed/BHD7qhZRoXQ"
      ]}
      takeaways={[
        { text: "Learn the theoretical concepts and diagrams." },
        { text: "Direct questions are possible from this topic." }
      ]}
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicFlynnsTaxonomy;
